/**
 * Auto-generated lucide icon component.
 *
 * @see https://lucide.dev/icons/chevron-right
 */
import { default as DefaultIcon } from '~icons/lucide/chevron-right';
import { Icon, type IconProps } from 'src/components/media-and-icons/icon';

export const ChevronRightIcon = (props: IconProps) => (
  <Icon icon={DefaultIcon} {...props} />
);
